import type { CoviChatItem } from "@/app-covi/model"

interface NotebookReceiptTarget {
  appendThreadItems: (threadId: string, items: CoviChatItem[]) => boolean
  loadThreadItems: (threadId: string) => CoviChatItem[]
  persistThreadItems: (threadId: string, items: CoviChatItem[]) => void
}

/** Legacy receipts retain their producer's ID namespace but have no provenance flag. */
export function isNotebookConversionReceipt(item: CoviChatItem): boolean {
  return (
    item.kind === "assistant" &&
    (item.notebookConversionReceipt === true || item.id.startsWith("notebook_"))
  )
}

/** Append to a mounted thread, or persist directly when its view was unmounted. */
export function appendNotebookReceipt(
  target: NotebookReceiptTarget,
  threadId: string,
  item: CoviChatItem,
): void {
  const receipt =
    item.kind === "assistant"
      ? { ...item, notebookConversionReceipt: true }
      : item
  if (target.appendThreadItems(threadId, [receipt])) {
    return
  }
  target.persistThreadItems(threadId, [
    ...target.loadThreadItems(threadId),
    receipt,
  ])
}
